const demoLangs = [
  [
    "en",
    "English"
  ],
  [
    "be",
    "BEnglish"
  ],
  [
    "de",
    "German"
  ],
  [
    "fr",
    "French"
  ],
  [
    "it",
    "Italian"
  ],
  [
    "es",
    "Spanish"
  ],
  [
    "nl",
    "Dutch"
  ],
  [
    "pt",
    "Portuguese"
  ],
  [
    "tr",
    "Turkish"
  ]
];

export const createLanguageTV = (languages) => languages.map(e => ({
  text: e[1],
  value: e[0]
}));

// console.log(createLanguageTV(demoLangs));